import ShareProject from 'components/commercetools-ui/organisms/project-builder/share-project';
import { TasticProps } from 'frontastic/tastics/types';
import { ctDataToFormData } from '../components/data';

const ShareProjectTastic = ({ data }: TasticProps<any>) => {
  return (
    <>
      <ShareProject
        data={data?.data_banner}
        projectFormData={ctDataToFormData(data?.data?.dataSource?.shoppingList || {})}
      />
    </>
  );
};

export default ShareProjectTastic;
